import { FC } from "react";
import { Form, Grid } from "antd";
import dayjs, { Dayjs } from "dayjs";
import i18n from "src/i18n";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { CalendarIcon } from "src/assets/Icons";
import { useTranslation } from "react-i18next";
import ArrivalComponentWeb from "./layouts/ArrivalComponent.web";
import ArrivalComponentMob from "./layouts/ArrivalComponent.mob";

const ArrivalSelectComponent = withConditionalComponent(ArrivalComponentWeb, ArrivalComponentMob);

const ArrivalComponent: FC<{ values: { journeyType?: number }; errorFields: string[] }> = ({ values, errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const form = Form.useFormInstance();
  const departureTime = Form.useWatch("preferredDepartureTime", form);

  if (values.journeyType === 1) return null;

  const name = "preferredReturnTime";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: CalendarIcon,
    label: t("Flights.search.return"),
    hasError,
    dependencies: ["preferredDepartureTime"],
    rules: [
      { required: true, message: t("Flights.search.returnRequired") },
      ({ getFieldValue }: any) => ({
        validator(_: any, value: any) {
          const preferredDepartureTime = getFieldValue("preferredDepartureTime");
          if (!value || !dayjs(preferredDepartureTime).isAfter(value)) {
            return Promise.resolve();
          }
          return Promise.reject(new Error(i18n.t("Flights.search.returnBeforeDeparture")));
        },
      }),
    ],
    disabledDate: (d: dayjs.Dayjs) =>
      d.isBefore(dayjs(), "day") || (departureTime ? d.isBefore(departureTime, "day") || d.isSame(departureTime, "day") : false),
    className:
      "flex-5 h-15! border-none! focus-within:ring-0! focus:outline-none! text-font-strong! w-full font-semibold",
  };

  return <ArrivalSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default ArrivalComponent;
